import * as primitives from "@mirage/service-typeahead-search/service/primitives";
import {
  SourceId,
  typeahead,
} from "@mirage/service-typeahead-search/service/types";
import { getSourceLimit } from "@mirage/service-typeahead-search/service/utils/source-helpers";
import * as wrappers from "@mirage/service-typeahead-search/service/utils/wrappers";
import * as rx from "rxjs";
import * as sourceScore from "../scoring/source-score";
import { getResultSection } from "../utils/section-mapper";

export const raw: typeahead.TaggedSearch = (
  query,
  mode,
  { config, grossLimit, sectionLimit },
) => {
  const sourceLimit = getSourceLimit(
    typeahead.ResultType.CalendarEvent,
    query,
    mode,
    config,
    grossLimit,
    sectionLimit,
  );
  const calendarEvents = config.calendarEvents;

  const sectionId = getResultSection(
    typeahead.ResultType.CalendarEvent,
    mode,
    query,
    config,
  );

  return rx.of(
    calendarEvents
      .map((source) => {
        const taggedResult = primitives.calendarEvent(source.uuid, source, {
          sectionId,
        });
        return sourceScore.score(query, config)(taggedResult);
      })
      .sort((a, b) => b.score! - a.score!)
      .slice(0, sourceLimit),
  );
};

export const search = wrappers.wrapped(SourceId.CalendarEvents, raw);
